import { CircularProgress, Typography } from '@equinor/eds-core-react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  height: 100%;
  flex: 1;
`;

interface CenteredLoaderProps {
  size?: 16 | 24 | 32 | 40 | 48;
  text?: string;
}

export function CenteredLoader({ size, text }: CenteredLoaderProps) {
  return (
    <Wrapper>
      <CircularProgress size={size} />
      {text && <Typography variant="body_long">{text}</Typography>}
    </Wrapper>
  );
}
